// removed by extract-text-webpack-plugin
module.exports = {"page":"ViewTalent_page__2luM","filterSectors":"ViewTalent_filterSectors__z-lS","viewOptions":"ViewTalent_viewOptions__Tuu-","selectedOption":"ViewTalent_selectedOption__1K6F","card":"ViewTalent_card__2DVZ","sector":"ViewTalent_sector__2Dnt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/KingstonConnect/styles/ViewTalent.scss
// module id = 232
// module chunks = 0